module.exports = __webpack_public_path__ + "img/img11.3bc8dd68.png";